import utils from '../src/utils'
const mutations = {
    GETASSEMBLYBASEINFO(state,data){//获取组卷中心基础信息
        state.departmentList = data.departments
    },
    GETPAPERBYSTORAGE(state,data){//根据试题篮里暂存的组信息、组内试题ID返回一个构建好的试卷详情
        state.segment_list.splice(0,state.segment_list.length,...data.segment_list)//后台返回的列表
    },
    SETASSEMBLYSTATE(state,{name,value}){
        state[name] = value
    },
    RENEWASSEMBLESTORE(state,data){//更新store
        let store = state.assemblyData
        if(Array.isArray(data.name)){
            data.name.forEach((el,index) => {
                if(index == data.name.length-1){
                    if(store.hasOwnProperty(el)){
                        store[el] = data.value
                    }else{
                        alert(el)
                    }
                }else{
                    store = store[el]
                }
            });
        }else{
            store = store[data.name] = data.value
        }
        if(data.type) return
        this.commit('SAVEASSEMBLESTORE')
    },
    RENEWASSEMBLESTOREBYID(state,data){//通过试题id更新store
        state.assemblyData.name = data.name
        state.assemblyData.department = data.department
        state.assemblyData.grade_id = data.grade_id
        state.assemblyData.paper_time = data.paper_time
        state.assemblyData.paper_type = data.paper_type
        state.assemblyData.subject_ids = data.subject_ids
        state.assemblyData.test_type = data.test_type
        let segment_list = []
        data.segment_list.forEach(one=>{
            let oneObj = {}
            oneObj.name = one.name
            oneObj.questions = []
            one.questions.forEach(two=>{
                let twoObj = {}
                if(two.material_id){
                    twoObj.material_id = two.material_id
                    twoObj.question_list = []
                    two.question_list.forEach(three=>{
                        let threeObj = {}
                        threeObj.test_id = three.id
                        threeObj.test_score = three.test_score
                        threeObj.padding_bottom = three.padding_bottom
                        threeObj.padding_underline = three.padding_underline
                        twoObj.question_list.push(threeObj)
                    })
                }else{
                    twoObj.test_id = two.id
                    twoObj.test_score = two.test_score
                    twoObj.padding_bottom = two.padding_bottom
                    twoObj.padding_underline = two.padding_underline
                }
                oneObj.questions.push(twoObj)
            })
            segment_list.push(oneObj)
        })
        state.assemblyData.segment_list.splice(0,state.assemblyData.segment_list.length,...segment_list)
        this.commit('SAVEASSEMBLESTORE')
    },
    RENEWASSEMBLELISTSTOREBYID(state,data){//排重后跟新列表数据
        let segment_list = []
        data.segment_list.forEach(one=>{
            let oneObj = {}
            oneObj.name = one.name
            oneObj.questions = []
            one.questions.forEach(two=>{
                let twoObj = {}
                if(two.material_id){
                    twoObj.material_id = two.material_id
                    twoObj.question_list = []
                    two.question_list.forEach(three=>{
                        let threeObj = {}
                        threeObj.test_id = three.id
                        threeObj.test_score = three.test_score
                        threeObj.padding_bottom = three.padding_bottom
                        threeObj.padding_underline = three.padding_underline
                        twoObj.question_list.push(threeObj)
                    })
                }else{
                    twoObj.test_id = two.id
                    twoObj.test_score = two.test_score
                    twoObj.padding_bottom = two.padding_bottom
                    twoObj.padding_underline = two.padding_underline
                }
                oneObj.questions.push(twoObj)
            })
            segment_list.push(oneObj)
        })
        state.assemblyData.segment_list = segment_list
        this.commit('SAVEASSEMBLESTORE')
    },
    SAVEASSEMBLESTORE(state){//保存现有store到本地
        if(!state.local_name) return
        utils.storage(state.local_name,state.assemblyData)
    },
    SETSELECTEDNODE(state,data){//设置选中节点
        state.currentNode.splice(0,state.currentNode.length,...data)
        console.log('当前节点：'+state.currentNode)
    },
    MOVEASSEMBLYNODE(state,data){//移动节点
        // if(data.length != state.currentNode.length) return
        console.log('目标节点：'+data)
        console.log('当前节点：'+state.currentNode)
        let list = state.segment_list
        let storageList = state.assemblyData.segment_list
        if(state.currentNode.length==2){//挪动大题
            let current = list[state.currentNode[0]].questions[state.currentNode[1]]
            list[state.currentNode[0]].questions.splice(state.currentNode[1], 1)
            data.length&&list[data[0]].questions.splice(data[1], 0,current)
            
            current = storageList[state.currentNode[0]].questions[state.currentNode[1]]
            storageList[state.currentNode[0]].questions.splice(state.currentNode[1], 1)
            data.length&&storageList[data[0]].questions.splice(data[1], 0,current)
        }
        if(state.currentNode.length==1){//挪动题组
            let current = list[state.currentNode[0]]
            list.splice(state.currentNode[0], 1)
            data.length&&list.splice(data[0], 0,current)
            
            current = storageList[state.currentNode[0]]
            storageList.splice(state.currentNode[0], 1)
            data.length&&storageList.splice(data[0], 0,current)
        }
        if(state.currentNode.length==3){//挪动材料小题
            let current = list[state.currentNode[0]].questions[state.currentNode[1]].question_list[state.currentNode[2]]
            list[state.currentNode[0]].questions[state.currentNode[1]].question_list.splice(state.currentNode[2], 1)
            data.length&&list[data[0]].questions[data[1]].question_list.splice(data[2], 0,current)

            current = storageList[state.currentNode[0]].questions[state.currentNode[1]].question_list[state.currentNode[2]]
            storageList[state.currentNode[0]].questions[state.currentNode[1]].question_list.splice(state.currentNode[2], 1)
            data.length&&storageList[data[0]].questions[data[1]].question_list.splice(data[2], 0,current)
        }
        state.currentNode.splice(0,state.currentNode.length,...data)
        this.commit('SAVEASSEMBLESTORE')
        // window.vm.$nextTick(function () {
        //     MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
        // })
        // this.commit('RENEWNODE')
    },
    QUESTIONTRANSFERGROUP(state,arr){//试题批量转入组
        let list = state.segment_list
        let storageList = state.assemblyData.segment_list
        let len = list[state.currentNode[0]].questions.length
        arr.forEach( item => {
            let current = list[item.split('-')[0]].questions[item.split('-')[1]]
            list[item.split('-')[0]].questions.splice(item.split('-')[1], 1)
            list[state.currentNode[0]].questions.splice(len, 0,current)
            
            current = storageList[item.split('-')[0]].questions[item.split('-')[1]]
            storageList[item.split('-')[0]].questions.splice(item.split('-')[1], 1)
            storageList[state.currentNode[0]].questions.splice(len, 0,current)
        })
        this.commit('SAVEASSEMBLESTORE')
    },
    SETSCORESHOW(state){//设置分数窗口显示隐藏
        state.setScoreShow = !state.setScoreShow
    },
    SETTOPICSCORE(state,score){//设置组卷题目分数
        if(state.currentNode.length == 1){
            let group = state.assemblyData.segment_list[state.currentNode[0]].questions
            let segment_list = state.segment_list[state.currentNode[0]].questions
            group.forEach((el,index)=>{
                if(el.material_id){
                    el.question_list.forEach((material,num)=>{
                        material.test_score = score
                        segment_list[index].question_list[num].test_score = score
                    })
                }else{
                    el.test_score = score
                    segment_list[index].test_score = score
                }
            })
        }
        if(state.currentNode.length == 2){
            if(state.assemblyData.segment_list[state.currentNode[0]].questions[state.currentNode[1]].material_id){
                state.assemblyData.segment_list[state.currentNode[0]].questions[state.currentNode[1]].question_list.forEach((el,index)=>{
                    el.test_score = score
                    state.segment_list[state.currentNode[0]].questions[state.currentNode[1]].question_list[index].test_score = score
                })
            }else{
                state.assemblyData.segment_list[state.currentNode[0]].questions[state.currentNode[1]].test_score = score
                state.segment_list[state.currentNode[0]].questions[state.currentNode[1]].test_score = score
            }
        }
        if(state.currentNode.length == 3){
            state.assemblyData.segment_list[state.currentNode[0]].questions[state.currentNode[1]].question_list[state.currentNode[2]].test_score = score
            state.segment_list[state.currentNode[0]].questions[state.currentNode[1]].question_list[state.currentNode[2]].test_score = score
        }
        this.commit('SAVEASSEMBLESTORE')
    },
    SETQUESTIONTRANSFERSHOW(state){//试题转移窗口显示
        state.questionTransferOutShow = !state.questionTransferOutShow
    },
    SETTRANSFERTESTSHOW(state){//试题转入题组窗口显示
        state.questionTransferEnterShow = !state.questionTransferEnterShow
    },
    SETTESTTRANSFER(state,aims){//设置试题转移
        if(state.currentNode[0] == aims) return
        let len = state.assemblyData.segment_list[aims].questions.length
        this.commit('MOVEASSEMBLYNODE',[aims,len])
    },
    SETASSEMBLETESTDETAILSSHOW(state){//试题详情窗口
        state.assembleTestDetailsShow = !state.assembleTestDetailsShow
    },
    DELASSEMBLEQUESTION(state,fn){//删除试题
        this.commit('MOVEASSEMBLYNODE',[])
        let len = 0
        state.segment_list.forEach(one=>{
            len += one.questions.length
        })
        if(len == 0){
            fn&&fn()
            // window.vm.$router.push('/TestSearch')
        }
    },
    ADDASSEMBLEGROUP(state,name){//添加组
        state.assemblyData.segment_list.push({name: name, questions: []})
        state.segment_list.push({name: name, questions: []})
        this.commit('SAVEASSEMBLESTORE')
    },
    CLEARASSEMBLYSTATE(state,data){//清空组件中心
        state.segment_list = []
        state.assemblyData = {
            name: null, //试卷名称
            department: '',//学部
            grade_id: '', //年级
            subject_ids: '', //学科ID列表，多个逗号隔开
            paper_type: 1, //试卷类型：1 考试卷, 2 测试卷
            test_type: '', //试题类型：1 客观题 2 主观题 3 主客混合 4 语音测评
            paper_time: '', //试卷考试时间分钟数
            id: '', //试卷ID，没有则为
            sub_title:null, //试卷副标题
            notice: '请填写注意事项', //试卷注意事项
            segment_list: [], //本地记录的试卷组列表
            options: { //试卷样式控制相关参数
                struct_title: 1, //显示主标题：1 显示  0 不显示
                struct_subtitle: 0, //显示副标题： 1 显示  0 不显示
                struct_student: 0, //显示考生信息: 1 显示  0 不显示
                struct_notice: 0, //显示注意事项: 1 显示  0 不显示
                struct_segment: 1, //显示分大题: 1 显示  0 不显示
                struct_segmentmemo: 1 //显示大题注释: 1 显示  0 不显示
            }
        }
        state.currentNode.splice(0,state.currentNode.length)
        this.commit('SAVEASSEMBLESTORE')
    },
    ADDASSEMBLY(state,{testData,type,fn}){//组卷中心添加小题
        if(this.getters.totalQuestion>=200){
            this._vm.$msgBox.alert('试题篮子最多加入200道小题！')
            return
        }
        let groupLen = state.assemblyData.segment_list.length
        let test = {test_id:testData.id,test_score:0,padding_bottom:0,padding_underline:0}
        let list = state.assemblyData.segment_list
        if(testData.material_id){
            let state = true
            list.forEach(one => {
                let level2 = utils.getObjectInArrayByValue(one.questions,{material_id:testData.material_id})
                if(level2 != -1){
                    state = false
                    let list2 = one.questions[level2].question_list
                    let level3 = utils.getObjectInArrayByValue(list2,{test_id:testData.id})
                    list2.push(test)
                }
            });
            if(state){
                let level1 = utils.getObjectInArrayByValue(list,{name:'材料题'})
                if(level1 != -1){
                    list[level1].questions.push({
                        material_id:testData.material_id,
                        question_list:[test]
                    })
                }else{
                    if(groupLen>=10){
                        this._vm.$msgBox.alert('最多添加十个组')
                        return
                    }
                    list.push({
                        name:'材料题',
                        questions:[{
                            material_id:testData.material_id,
                            question_list:[test]
                        }]
                    })
                }
            }
        }else{
            let level1 = utils.getObjectInArrayByValue(list,{name:testData.type_name})
            if(level1 != -1){
                list[level1].questions.push(test)
            }else{
                if(groupLen>=10){
                    this._vm.$msgBox.alert('最多添加十个组')
                    return
                }
                list.push({
                        name:testData.type_name,
                        questions:[test]
                    })
            }
        }
        this.commit('SAVEASSEMBLESTORE')
        this.commit('CHANGESIDEBARSHOW','1')
        fn(type)
    },
    ADDASSEMBLYS(state,{material_id,material_test,fn,type,type_name}){//组卷中心添加材料整题
        if(this.getters.totalQuestion+material_test.length>200){
            this._vm.$msgBox.alert('组卷中心最多加入200道小题！')
            return
        }
        let groupLen = state.assemblyData.segment_list.length
        let list = state.assemblyData.segment_list
        var animation = true
        let test = material_test.map(el=>{
            let obj = {}
            obj.test_id = el
            obj.test_score = 0
            obj.padding_bottom = 0
            obj.padding_underline = 0
            return obj
        })
        let material = {
            material_id:material_id,
            question_list:test
        }
        let has = true
        list.forEach(one=>{
            let index = utils.getObjectInArrayByValue(one.questions,{material_id:material_id})
            if(index >= 0){
                if(one.questions[index].question_list.length == material_test.length){
                    this._vm.$msgBox.alert('该材料下试题已全部加入组卷中心')
                    animation = false
                }else{
                    one.questions.splice(index,1,material)
                }
                has = false
            }
        })
        if(has){
            let level1 = utils.getObjectInArrayByValue(list,{name:'材料题'})
            if(level1 == -1){
                if(groupLen>=10){
                    this._vm.$msgBox.alert('最多添加十个组')
                    return
                }
                list.push({
                    name:'材料题',
                    questions:[material]
                })
            }else{
                list[level1].questions.push(material)
            }
        }
        this.commit('SAVEASSEMBLESTORE')
        if(animation){
            this.commit('CHANGESIDEBARSHOW','1')
            fn(type)
        }
    },
    CUTASSEMBLY(state,{testData,type,fn}){//移除组卷中心试题
        let list = state.assemblyData.segment_list
        list.forEach(one=>{
            if(testData.material_id){
                let level1 = utils.getObjectInArrayByValue(one.questions,{material_id:testData.material_id})
                if( level1 > -1){
                    let level2 = utils.getObjectInArrayByValue(one.questions[level1].question_list,{test_id:testData.id})
                    if(level2 > -1){
                        one.questions[level1].question_list.splice(level2,1)
                        if(one.questions[level1].question_list.length == 0){
                            one.questions.splice(level1,1)
                        }
                    }
                }
            }else{
                let index = utils.getObjectInArrayByValue(one.questions,{test_id:testData.id})
                if(index > -1){
                    one.questions.splice(index,1)
                }
            }
        })
        this.commit('SAVEASSEMBLESTORE')
        fn(type)
    },
    RENEWASSEMBLY(state){
        state.assemblyData = utils.storage(state.local_name)
        state.segment_list = []
    },
    SETBOXDRAGENTER(state,data){
        state.boxDragEnter = data
    },
    SETSCROLLTIMER(state,data){//设置滚动条定时
        clearTimeout(state.scrollTimer)
        if(data){
            state.scrollTimer = setInterval(()=>{
                data.fn(data.type)
            },data.time||30)
        }
    }
}

export default mutations


// WEBPACK FOOTER //
// ./packages/question-assembly/store/mutations.js